@if (theftReports().length === 0) {
  <app-pan-inline-alert class="my-2" type="info">No suspicious incidents have been found yet.</app-pan-inline-alert>
}

<div class="w-full flex flex-col items-start gap-2 mb-2">
  <div class="w-full flex flex-row justify-end">
    <div class="mr-auto flex flex-row gap-2">
      <app-pan-button
        data-testid="create-report-button"
        color="primary"
        panRole
        [roles]="['admin', 'branch-owner', 'branch-manager', 'market-manager', 'location-manager', 'guest']"
        [swal]="createReportSwal"
        [disabled]="selectedReports().length === 0"
        [state]="creatingReport() ? 'loading' : 'default'"
      >
        Create Report
      </app-pan-button>

      <div
        class="flex flex-row gap-2"
        panRole
        [roles]="['admin', 'branch-owner', 'branch-manager', 'market-manager', 'validator', 'location-manager']"
      >
        @if (selectedReports().length > 0) {
          <div class="mr-2 border-l-2"></div>
        }

        @if (selectedReports().length > 1) {
          <app-pan-button [swal]="mergeCasesSwal"> Merge cases </app-pan-button>
        }
        @if (selectedReports().length > 0) {
          <app-pan-button color="warning" [swal]="notATheftSwal"> Not a Theft </app-pan-button>
        }

        <app-pan-button
          [color]="canCreateArReport() ? 'primary' : 'default'"
          [swal]="createArReportSwal"
          [disabled]="!canCreateArReport()"
          [state]="creatingArReport() ? 'loading' : 'default'"
        >
          Create AR Report
        </app-pan-button>
      </div>
    </div>

    <app-pan-button
      [color]="hasAssetRecoveryAccess() ? 'primary' : 'default'"
      [disabled]="!hasAssetRecoveryAccess()"
      (click)="navigateToAssetRecoveryPage()"
    >
      Asset Recovery
    </app-pan-button>
  </div>

  <app-pan-inline-alert class="w-full" type="info"> You have selected {{ selectedReports().length }} cases. </app-pan-inline-alert>
</div>

<ag-grid-angular #reportGrid [rowData]="ungroupedTheftReports()" [columnDefs]="columnDefs" [gridOptions]="tableDef"></ag-grid-angular>

<swal
  #notATheftSwal
  title="Mark As Not A Theft?"
  text="Are you sure you want to mark {{ selectedReports().length }} cases as 'Not a Theft'?"
  icon="warning"
  confirmButtonText="Yes, Mark"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="markNoTheft()"
>
</swal>

<swal
  #mergeCasesSwal
  title="Merge Cases?"
  text="Are you sure you want to merge {{ selectedReports().length }} cases?"
  icon="warning"
  confirmButtonText="Yes, Merge"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="mergeCases()"
>
</swal>

<swal
  #createArReportSwal
  title="Create Asset Recovery Report"
  text="What would you like to name the report for your selected case?"
  icon="question"
  confirmButtonText="Create Report"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="createArReport($event)"
  input="text"
  [inputAttributes]="{ minlength: '4', maxlength: '25' }"
  [inputValidator]="reportNameValidate"
>
</swal>

<swal
  #createReportSwal
  title="Create Report"
  text="What would you like to name the report for the {{ selectedReports().length }} selected incidents?"
  icon="question"
  confirmButtonText="Create Report"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="createReport($event)"
  input="text"
  [inputAttributes]="{ minlength: '4', maxlength: '25' }"
  [inputValidator]="reportNameValidate"
>
</swal>
